import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-448c5f1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-[#F5F5F5] w-[100%] info-newsbox" }
const _hoisted_2 = { class: "flex py-[20px] text-[14px] text-[#606266]" }
const _hoisted_3 = { class: "w-[100%] bg-white rounded-sm py-[60px]" }
const _hoisted_4 = { class: "w-[1080px] mx-auto" }
const _hoisted_5 = { class: "text-center text-[#333] text-[22px]" }
const _hoisted_6 = { class: "flex justify-center py-[20px] text-[#666] text-[14px] leading-[14px]" }
const _hoisted_7 = { class: "mr-[20px]" }
const _hoisted_8 = ["innerHTML"]

import { watchEffect, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getDetail } from "@/http/api";
interface IResult {
  content: string;
  createTime: string;
  createBy: string;
  title: string;
  digest: string;
  pv: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PageDetail',
  setup(__props) {

const path = ref("");
const name = ref("");
const router = useRouter();
const page = ref<IResult>();
const pageType = {
  "/news": "新闻中心",
  "/policies": "政策法规",
  '/partyBuilding': "国企党建",
  '/aboutus': "关于我们",
};
watchEffect(() => {
  path.value = "/" + router.currentRoute.value.path.split("/")[1];
  name.value = pageType[path.value];
});
function goRoute(path) {
  router.push(path);
}
onMounted(() => {
  const { id } = router.currentRoute.value.query;
  getDetail<IResult>({ id }).then((res) => {
    page.value = res.data;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 当前位置>"),
        _createVNode(_component_el_link, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goRoute('/')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("首页")
          ]),
          _: 1
        }),
        _createTextVNode(" >"),
        _createVNode(_component_el_link, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goRoute(path.value)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(name.value), 1)
          ]),
          _: 1
        }),
        _createTextVNode(" >" + _toDisplayString(name.value) + "详情 ", 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(page.value?.title || "政策指导文件"), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, "时间 " + _toDisplayString(page.value?.createTime), 1),
            _createElementVNode("span", null, "浏览量 " + _toDisplayString(page.value?.pv), 1)
          ]),
          _createElementVNode("div", {
            innerHTML: page.value?.content,
            class: "page-content indent-[2em]"
          }, null, 8, _hoisted_8)
        ])
      ])
    ])
  ]))
}
}

})